
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { CenteredAuthView } from '@Components/Auth/Auth.styled';
import Dialogue from '@Components/Auth/Dialogue';
import Layout from '@Components/Layout';
import { RIA } from '@Constants/ACL';
import { NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import dynamic from 'next/dynamic';
import React, { useState } from 'react';
import { Col, Container, Row } from 'styled-bootstrap-grid';
const ForgotPasswordForm = dynamic(() => import('@Components/Auth/ForgotPassword'));

type Props = {};
const ForgotPasswordPage: NextPage = ({}: Props) => {
  const { t: tAuth } = useTranslation('Auth');
  const [formSuccessMessage, setFormSuccessMessage] = useState<string>('');

  return (
    <Layout
      seoData={{
        title: tAuth('forget'),
      }}
      hideNavbar={true}
    >
      <CenteredAuthView>
        <Container fluid>
          <Row justifyContent="center">
            <Col col={12} xxl={5} xl={6} lg={8}>
              <ForgotPasswordForm setFormSuccessMessage={setFormSuccessMessage} />
              {formSuccessMessage && (
                <Dialogue
                  title={tAuth('send_success')}
                  message={formSuccessMessage}
                  cta={{
                    link: '/',
                    message: tAuth('ok'),
                  }}
                />
              )}
            </Col>
          </Row>
        </Container>
      </CenteredAuthView>
    </Layout>
  );
};

 async function _getStaticProps() {
  return {
    props: {
      ACL: {
        action: RIA,
      },
    },
  };
}

export default ForgotPasswordPage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/auth/forgot-password',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  